import { Outlet } from 'react-router';
import { AuthProvider } from '@/lib/auth-context';

export function RootLayout() {
  return (
    <AuthProvider>
      <Outlet />
    </AuthProvider>
  );
}
